import React, { useMemo } from 'react';
import { extractSSOParams, getBrandingImagePath } from '@smart-builder/rest';
import { LoginForm } from './LoginForm';
import { LoginSSO } from './LoginSSO';

const App: React.FC = () => {
  const { ssoParams } = extractSSOParams();

  return (
    <main
      className="app"
      style={{
        backgroundImage: `url("${getBrandingImagePath('background')}")`,
      }}
    >
      <div className="login-container">
        <div
          className="login-branding"
          style={{ backgroundImage: `url("${getBrandingImagePath('logo')}")` }}
        />
        {ssoParams.size ? <LoginSSO /> : <LoginForm />}
      </div>
    </main>
  );
};

export default App;
